import React from 'react'

import { theme } from '../../../styles/theme'
import { Actions } from '../../commons'
import { FaInfo, FaPause, FaPencil, FaPlay, FaTrash } from 'react-icons/fa6'
import PermissionGate from '../../PermissionGate'

export interface TableActionsProps {
  handleDelete?: () => void
  handleActive?: () => void
  handleEdit?: () => void
  handleDesactive?: () => void
  handleView?: () => void
  isActive?: boolean
  // Permissões específicas para cada ação
  canEdit?: boolean
  canDelete?: boolean
  canView?: boolean
  canActivate?: boolean
}

const TableActions: React.FunctionComponent<TableActionsProps> = ({
  handleDelete,
  handleActive,
  handleDesactive,
  handleEdit,
  isActive,
  handleView,
  canEdit = true,
  canDelete = true,
  canView = true,
  canActivate = true,
}) => {
  return (
    <Actions>
      {typeof isActive !== 'undefined' && canActivate && (
        <>
          {isActive ? (
            <span onClick={() => handleDesactive && handleDesactive()}>
              <FaPause color={theme.colors.primary} size={15} />
            </span>
          ) : (
            <span onClick={() => handleActive && handleActive()}>
              <FaPlay color={theme.colors.primary} size={15} />
            </span>
          )}
        </>
      )}

      {handleView && canView && (
        <span onClick={() => handleView()}>
          <FaInfo color={theme.colors.primary} size={15} />
        </span>
      )}

      {handleEdit && canEdit && (
        <span onClick={() => handleEdit()}>
          <FaPencil color={theme.colors.primary} size={15} />
        </span>
      )}

      {handleDelete && canDelete && (
        <span onClick={() => handleDelete()}>
          <FaTrash color={theme.colors.primary} size={15} />
        </span>
      )}
    </Actions>
  )
}

export default TableActions
